"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var form_builder_validator_1 = __importDefault(require("@hikakaku/shared/validator/forms/form_builder_validator"));
var AbstractInputStore = /** @class */ (function () {
    function AbstractInputStore(props) {
        var _this = this;
        this.hidden = false;
        this.valid = true;
        this.validate = function () {
            if (_this.preCheck) {
                _this.valid = form_builder_validator_1.default.preValidateInput(_this);
            }
        };
        this.handleBlur = function () {
            _this.onBlur && _this.onBlur(_this.value && String(_this.value));
        };
        this.observeValueChanged = function (fn, opts) {
            if (opts === void 0) { opts = { fireImmediately: true }; }
            (0, mobx_1.reaction)(function () { return _this._value; }, fn, opts);
        };
        /**
         * @deprecated validatorでの互換用なので基本的に使わないでください
         */
        this.getValue = function () {
            return _this.value;
        };
        /**
         * @deprecated validatorでの互換用なので基本的に使わないでください
         */
        this.setValue = function (value) {
            _this.value = value;
        };
        /**
         * @deprecated validatorでの互換用なので基本的に使わないでください
         */
        this.setAlertText = function () {
            // 何もしません
        };
        this.type = props.type;
        this.id = props.name;
        this.label = props.label;
        this.name = props.name;
        this.rawName = props.rawName || props.name;
        this.necessary = props.necessary;
        this.description = props.description;
        this.disabled = props.disabled || false;
        this.preCheck = props.preCheck === undefined ? true : props.preCheck;
        this.onBlur = props.onBlur;
        this.value = props.defaultValue || undefined;
        (0, mobx_1.reaction)(function () { return _this._value; }, this.validate, { fireImmediately: true });
    }
    Object.defineProperty(AbstractInputStore.prototype, "value", {
        get: function () {
            return this.active ? this._value : undefined;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractInputStore.prototype, "valueText", {
        get: function () {
            return String(this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractInputStore.prototype, "active", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractInputStore.prototype, "valid", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractInputStore.prototype, "_value", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], AbstractInputStore.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AbstractInputStore.prototype, "valueText", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], AbstractInputStore.prototype, "active", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractInputStore.prototype, "validate", void 0);
    return AbstractInputStore;
}());
exports.default = AbstractInputStore;
